import React, { FC, useEffect, useRef } from "react";
import { OrganizationsListItem } from "./index";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { getOrganizations } from "toolkit/organizations/organizations.thunks";
import { ReactComponent as LoadingIcon } from "images/load.svg";
import { NoData } from "components-new/NoData/NoData";
import { ChangeArchiveMode, changeMode, ClearOrganizations } from "toolkit/organizations/organizations.slice";
import { useLocation } from "react-router-dom";
import "./OrganizationsList.styles.sass";
import { OrganizationResponse } from "libs/apiClient/data-contracts";

export const OrganizationsList: FC = () => {
	const dispatch = useAppDispatch();
	const { organizationsList, searchMode, searchPending, searchedList, mode, archiveMode } = useAppSelector(
		(state) => state.organizations,
	);

	const location = useLocation();

	useEffect(() => {
		if ((location.pathname.includes("/archive") && !archiveMode) || mode === "categorization") return;
		dispatch(ClearOrganizations());
		dispatch(
			getOrganizations({
				part: 1,
				quantity: 50,
				isCategorization: mode === "categorization",
				archiveMode: location.pathname.includes("/archive"),
			}),
		);
		//eslint-disable-next-line
	}, [archiveMode, mode]);

	useEffect(() => {
		return () => {
			dispatch(ChangeArchiveMode(false));
			dispatch(changeMode(""));
		};
		//eslint-disable-next-line
	}, []);
	const scrollRef: any = useRef(null);

	const renderBlock = (list: OrganizationResponse[], isLast?: boolean) => {
		return list.map((organization, i) => (
					<OrganizationsListItem
						key={organization.id}
						organization={organization}
						last={isLast ? isLast : i === list.length - 1 && i !== 0}
						parentRef={scrollRef}
					/>
				));
	};

	return (
		<tbody data-comment-false={true} ref={scrollRef} className="organizations-table-body">
			{organizationsList.length ? (
				<>
					{!searchMode &&
						renderBlock(archiveMode ? organizationsList : organizationsList.filter((item) => !item.parent), false)}
					{searchMode &&
						(searchPending ? (
							<tr className={'organizations-table-body-row organizations-table-body-row-empty'}>
								<td colSpan={6}>
									<div className="loading-wrp">
										<LoadingIcon className="loading-icon" />
									</div>
								</td>
							</tr>
						) : searchedList.length ? (
							renderBlock(searchedList)
						) : (
							<tr className={'organizations-table-body-row organizations-table-body-row-empty '}>
								<td colSpan={6}>
									<NoData title="Ничего не найдено" />
								</td>
							</tr>
						))}
				</>
			) : (
				<tr className={'organizations-table-body-row organizations-table-body-row-empty '}>
					<td colSpan={6}>
						<NoData title="Данные отсутствуют"></NoData>
					</td>
				</tr>
			)}
		</tbody>
	);
};
